import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/update/tenant.update.mutation.gql"
import type {
  TenantUpdateMutation,
  TenantUpdateMutationVariables,
} from "@/v2-backoffice-client/tenant/update/__types__/tenant.update.mutation"

type Options = MutationHookOptions<
  TenantUpdateMutation,
  TenantUpdateMutationVariables
>

export function useTenantUpdateMutation(options?: Options) {
  return useMutation<TenantUpdateMutation, TenantUpdateMutationVariables>(
    mutation,
    options,
  )
}
